export default {
  xxs: 375,
  xs: 450,
  sm: 620,
  md: 768,
  ml: 870,
  lg: 1024,
  xl: 1300,
  xxl: 1440,
  xxxl: 1740,
  xxxxl: 1900,
};
